import NewGalleryImageForm from "./NewGalleryImageForm";

const NewGalleryImage = () => {

  return (
    <div className="category-container">

      <NewGalleryImageForm />

    </div>
  );

};

export default NewGalleryImage;
